// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_2dHm-","title":"index_title_7UkHv","list_box":"index_list_box_3BCAY","more":"index_more_GAwmq"};